import { captureException } from "@sentry/vue";

export enum LogLevel {
  DEBUG = 10,
  INFO = 20,
  WARN = 30,
  ERROR = 40
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function useLogger(name = "ROOT", level: LogLevel = LogLevel.DEBUG) {
  const isProd = import.meta.env.MODE === "production";

  const commonStyle = [
    "padding: .3em",
    "border-radius: 2px",
    "font-size: 1.25em",
    "font-weight: bold"
  ];

  const debugStyle = [
    ...commonStyle,
    "color: #666",
    "background-color: #f6f6f6"
  ].join(";");

  const infoStyle = [
    ...commonStyle,
    "color: #fff",
    "background-color: #0087BD"
  ].join(";");

  const warnStyle = [
    ...commonStyle,
    "font-size: 1.5em",
    "background-color: #FFD300",
    "color: #333"
  ].join(";");

  const errorStyle = [
    ...commonStyle,
    "background-color: #C40233",
    "color: #fff",
    "font-size: 1.75em"
  ].join(";");

  function debug(...args: unknown[]): void {
    if (LogLevel.DEBUG >= level) {
      !isProd && console.log(`%c🙂DEBUG>${name}`, debugStyle, ...args);
    }
  }
  function info(...args: unknown[]): void {
    if (LogLevel.INFO >= level) {
      !isProd && console.log(`%c🤔INFO>${name}`, infoStyle, ...args);
    }
  }
  function warn(...args: unknown[]): void {
    if (LogLevel.WARN >= level) {
      !isProd && console.log(`%c🤕WARN > ${name}`, warnStyle, ...args);
    }
  }
  function error(...args: unknown[]): void {
    if (LogLevel.ERROR >= level) {
      if (isProd) {
        captureException(args);
      } else {
        console.log(`%c🤮ERROR > ${name}`, errorStyle, ...args);
      }
    }
  }

  return { debug, info, warn, error };
}

/*

in a setup function you would call

import { useLogger } from '@/src/composables/logger'
const { debug } = useLogger("myname")

// use here
debug({message: "everything broken"})

// or use in the template
return { debug }

*/

// TODO APOLLO LOGGER
// NEED TYPES

//   apollo(operation, ellapsedMS, result) {
//     const operationType = operation.query.definitions[0].operation;
//     let label = "";
//     let styles = [];
//     const hasErrors = result.errors !== undefined;
//     if (operationType === "query") {
//       label = `%c↲ ${operation.operationName} %c${ellapsedMS} ms`;
//       styles = [
//         "color: #343488; font-style: oblique; font-weight: lighter;",
//         "font-weight: normal; color: blue; font-size: 0.8em;",
//       ];
//     } else {
//       label = `%c↱ ${operation.operationName} %c${ellapsedMS} ms`;
//       styles = [
//         "color: #B93445; font-size: 0.95em; font-style: oblique; font-weight: lighter;",
//         "font-weight: normal; color: blue; font-size: 0.8em;",
//       ];
//     }
//     if (hasErrors) {
//       console.group(label, ...styles);
//     } else {
//       console.groupCollapsed(label, ...styles);
//     }

//     if (result.errors !== undefined) {
//       result.errors.forEach(e => {
//         console.error(`ERROR: ${e.message}`, e.extensions);
//       });
//       console.log("variables", operation.variables);
//     } else {
//       console.log("variables", operation.variables);
//       console.log("%cresult", "color: darkgreen; font-weight: bold", result.data);
//     }
//     console.groupEnd(label);
//   }
// }
